<template>
  <Allow
      title="Включите сообщения группы"
      :content="content"
      @action="action"
  ></Allow>
</template>

<script>
import Allow from '@/components/Allow'
import {closeApp, getGroupMessageSettingsUrl, windowOpen} from '@/services/vkApi'

export default {
  name: 'AllowMessages',
  components: {Allow},
  data () {
    return {
      content: 'С помощью сообщений вы сможете автоматически оповещать клиентов о создании заказов, ' +
          'сообщить о приходе или наличии товара, а также сообщить о распродажах и конкурсах сообщества.<br/><br/>' +
          'Включить сообщения вы сможете в настройках группы ("Управление" => "Сообщения" => "Включить")'
    }
  },
  methods: {
    action () {
      closeApp()
      windowOpen(getGroupMessageSettingsUrl())
    }
  }
}
</script>

<style scoped>

</style>